import { render, staticRenderFns } from "./Submenu.vue?vue&type=template&id=330cc0dc&scoped=true&"
import script from "./Submenu.vue?vue&type=script&lang=ts&"
export * from "./Submenu.vue?vue&type=script&lang=ts&"
import style0 from "./Submenu.vue?vue&type=style&index=0&id=330cc0dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330cc0dc",
  null
  
)

export default component.exports